import { supabase } from '../config/supabaseClient';

export interface ExpenseInput {
  date: string; // ISO date
  amount: number;
  currency?: string;
  category?: string;
  vendor?: string;
  notes?: string;
  is_fixed?: boolean;
}

export interface ExpenseRecord extends ExpenseInput {
  id: string;
  user_id: string;
  created_at: string;
}

export const expenseService = {
  async create(expense: ExpenseInput): Promise<ExpenseRecord> {
    try {
      const { data: session } = await supabase.auth.getSession();
      const userId = session.session?.user?.id;
      if (!userId) throw new Error('Not authenticated');

      const payload = {
        user_id: userId,
        date: expense.date,
        amount: expense.amount,
        currency: expense.currency ?? 'GBP',
        category: expense.category ?? null,
        vendor: expense.vendor ?? null,
        notes: expense.notes ?? null,
        is_fixed: expense.is_fixed ?? false,
      };

      const { data, error } = await supabase.from('expenses').insert(payload).select().single();
      if (error) throw error;
      return data as ExpenseRecord;
    } catch (e: any) {
      console.error('expenseService.create error', e);
      throw new Error(e?.message || 'Failed to save expense');
    }
  },

  async list(params: { from?: string; to?: string; limit?: number }): Promise<ExpenseRecord[]> {
    try {
      const { data: session } = await supabase.auth.getSession();
      const userId = session.session?.user?.id;
      if (!userId) throw new Error('Not authenticated');

      let query = supabase.from('expenses').select('*').eq('user_id', userId).order('date', { ascending: false });
      if (params.from) query = query.gte('date', params.from);
      if (params.to) query = query.lte('date', params.to);
      if (params.limit) query = query.limit(params.limit);

      const { data, error } = await query;
      if (error) throw error;
      return (data || []) as ExpenseRecord[];
    } catch (e: any) {
      console.error('expenseService.list error', e);
      return [];
    }
  }
};
